import { ReactNode } from 'react';

export enum UiLanguageEnum {
  ENGLISH = 'en-US',
  GERMAN = 'de-DE',
  SPANISH = 'es-ES',
  PORTUGUESE = 'pt-BR',
  ITALIAN = 'it-IT',
  FRENCH = 'fr-FR',
  JAPANESE = 'ja-JP',
}

export type TLanguageSwitcherProps = {
  component?: 'Select' | 'MenuItem';
  onLanguageChange?: (code: UiLanguageEnum) => void;
  compact?: boolean;
};

export type TLanguageOption = {
  code: UiLanguageEnum;
  flag: ReactNode;
};
